import { Injectable } from "@angular/core";
import { LocalStorageService } from "./local-storage.service";
import {
  IRequestPwdRecovery,
  IResetPassword,
  IUserCredentials,
} from "../data-types/user.interface";
import { HttpClientService } from "./http-client.service";
import { EStorageType } from "../data-types/storage.enum";
import { IService } from "../data-types/services.interface";

@Injectable({
  providedIn: "root",
})
export class ServicesService {
  static instance: ServicesService = new ServicesService();
  constructor() {
    return (ServicesService.instance = ServicesService.instance || this);
  }
  public async getServices(): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "services";
      let headers: any = {};
      // let body: ICoworking = coworking;

      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          // LocalStorageService.instance.set();
          // LocalStorageService.instance.set(
          //   EStorageType.RefresToken,
          //   result.refresh_token
          // );
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
